import DashboardSection from "../components/DashboardSection";

function money(value) {
  const amount = Number(value || 0);
  return `$${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function SalesChart({ overview, period, onPeriodChange }) {
  const rows = overview?.rows || [];
  const maximumValue = Math.max(...rows.map((item) => Number(item.value || 0)), 0);
  const totalLabel = period === "month" ? "Monthly total" : "Weekly total";

  return (
    <DashboardSection
      title="Sales Overview"
      description="Daily gross sales for the current week."
      action={
        <select className="admin-period-select" value={period} aria-label="Select sales period" onChange={(event) => onPeriodChange(event.target.value)}>
          <option value="week">This week</option>
          <option value="month">This month</option>
        </select>
      }
    >
      <div className="sales-chart">
        <div className="sales-chart__summary">
          <span>{totalLabel}</span>
          <strong>{money(overview?.total)}</strong>
        </div>

        <div className="sales-chart__plot">
          {rows.map((item) => {
            const numericValue = Number(item.value || 0);
            const height = maximumValue > 0 ? `${Math.max(8, (numericValue / maximumValue) * 100)}%` : "8%";
            return (
              <div className="sales-chart__column" key={`${item.label}-${item.date || ""}`}>
                <div className="sales-chart__bar-area">
                  <span className="sales-chart__bar" style={{ height }} title={`${item.label}: ${money(numericValue)}`} />
                </div>
                <span className="sales-chart__label">{item.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </DashboardSection>
  );
}

export default SalesChart;
